$(document).on("click", ".block_our-reps-dropdown", function () {
  $(this).parents(".block_our-reps-inner").toggleClass("active");
  $(this).parents(".block_our-reps-inner").find(".block_our-reps-dropdown-info").slideToggle();
  $('.slick-slider').slick('setPosition');
});

$(".block__contact--main").parents(".block_our-reps-dropdown-info-inner").addClass("block_type-form")
if($(window).width() < 750){
  $('.block_our-reps-dropdown-info-inner:not(.block_type-form)').slick({
    dots: false,
    infinite: false,
    speed: 300,
    arrow: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      // {
      //   breakpoint: 1024,
      //   settings: {
      //     slidesToShow: 2,
      //     slidesToScroll: 1,
      //     infinite: true,
      //     dots: true
      //   }
      // },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}